/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CustomTaskStepPriority } from './customTaskStepPriority';
import type { CustomTaskStepTaskNoteDoc } from './customTaskStepTaskNoteDoc';
import type { StepScheduleDelay } from './stepScheduleDelay';
import type { StepScheduleImmediate } from './stepScheduleImmediate';
import type { StepScheduleSoonestAt } from './stepScheduleSoonestAt';

export interface CustomTaskStep {
  schedule: StepScheduleImmediate | StepScheduleSoonestAt | StepScheduleDelay;
  priority?: CustomTaskStepPriority;
  type: 'custom_task';
  task_note_doc?: CustomTaskStepTaskNoteDoc;
}
